import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a3ab1f44")

_pushScopeId("data-v-a3ab1f44")
const _hoisted_1 = { class: "detail-wrapper" }
const _hoisted_2 = { class: "detail-form" }
const _hoisted_3 = { class: "shinsei-info" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 申請ID： ")
const _hoisted_5 = { class: "text-info" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" ステータス： ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 企業内進捗： ")
const _hoisted_8 = { class: "text-info" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 企業内進捗： ")
const _hoisted_10 = { class: "text-info" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 登録日時： ")
const _hoisted_12 = { class: "text-info" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 更新日時： ")
const _hoisted_14 = { class: "text-info" }
const _hoisted_15 = { class: "shinseisha-info" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 会社名： ")
const _hoisted_17 = { class: "text-info" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" グループ名： ")
const _hoisted_19 = { class: "text-info" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 登録者名： ")
const _hoisted_21 = { class: "text-info" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 部署名： ")
const _hoisted_23 = { class: "text-info" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 管理者名： ")
const _hoisted_25 = { class: "text-info" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 部署名： ")
const _hoisted_27 = { class: "text-info" }
const _hoisted_28 = { class: "shinsei-content" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "tip" }, "今回の委託で利用するMDBファイルを選択してください。", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "tip" }, "上記で選択したファイルのうち、利用する項目を選択してください。", -1)
const _hoisted_31 = { class: "ult-content" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" ULT管理者名： ")
const _hoisted_33 = { class: "text-info" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" ULT登録者名： ")
const _hoisted_35 = { class: "text-info" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" ULTコメント")
const _hoisted_37 = { class: "detail-btns" }
const _hoisted_38 = { class: "action-btns" }
const _hoisted_39 = { class: "shinseisha-btns" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 申請")
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" 申請")
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" 承認")
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" 複写")
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" 一時保存")
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" 取消")
const _hoisted_46 = { class: "shoninsha-btns" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" 承認")
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" 承認")
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" 承認")
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" 保留")
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" 保留")
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" 保留")
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" 取消")
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" 取消")
const _hoisted_55 = { class: "common-btns" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" 削除")
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" キャンセル")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_cus_panel = _resolveComponent("cus-panel")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_collapse_transition = _resolveComponent("el-collapse-transition")
  const _component_Doijiko = _resolveComponent("Doijiko")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_button = _resolveComponent("el-button")
  const _component_ShoninComment = _resolveComponent("ShoninComment")
  const _component_select_dialog = _resolveComponent("select-dialog")
  const _directive_access = _resolveDirective("access")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.id)
        ? (_openBlock(), _createBlock(_component_cus_panel, {
            key: 0,
            title: "申請情報"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", null, [
                  _hoisted_4,
                  _createVNode("span", _hoisted_5, _toDisplayString(_ctx.panels.shinseiInfo.shinseiId), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_6,
                  _createVNode(_component_el_tag, {
                    size: "mini",
                    type: _ctx.statusFilter(_ctx.panels.shinseiInfo.status)
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.panels.shinseiInfo.status), 1)
                    ]),
                    _: 1
                  }, 8, ["type"])
                ]),
                _withDirectives(_createVNode("div", null, [
                  _hoisted_7,
                  _createVNode("span", _hoisted_8, _toDisplayString(_ctx.panels.shinseiInfo.shinchokuShinsei), 1)
                ], 512), [
                  [_directive_access, _ctx.ELEMENT_ACCESS.shinseiShinchokuShinseiText]
                ]),
                _withDirectives(_createVNode("div", null, [
                  _hoisted_9,
                  _createVNode("span", _hoisted_10, _toDisplayString(_ctx.panels.shinseiInfo.shinchokuShonin), 1)
                ], 512), [
                  [_directive_access, _ctx.ELEMENT_ACCESS.shinseiShinchokuShoninText]
                ]),
                _createVNode("div", null, [
                  _hoisted_11,
                  _createVNode("span", _hoisted_12, _toDisplayString(_ctx.panels.shinseiInfo.torokuDate), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_13,
                  _createVNode("span", _hoisted_14, _toDisplayString(_ctx.panels.shinseiInfo.kousinDate), 1)
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.id)
        ? (_openBlock(), _createBlock(_component_cus_panel, {
            key: 1,
            title: "申請者情報"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_15, [
                _createVNode(_component_el_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_col, { span: 7 }, {
                      default: _withId(() => [
                        _hoisted_16,
                        _createVNode("span", _hoisted_17, _toDisplayString(_ctx.panels.shinseishaInfo.kaishaNm), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 7 }, {
                      default: _withId(() => [
                        _hoisted_18,
                        _createVNode("span", _hoisted_19, _toDisplayString(_ctx.panels.shinseishaInfo.groupNm), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_col, { span: 7 }, {
                      default: _withId(() => [
                        _hoisted_20,
                        _createVNode("span", _hoisted_21, _toDisplayString(_ctx.panels.shinseishaInfo.torokuKjnNm), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 7 }, {
                      default: _withId(() => [
                        _hoisted_22,
                        _createVNode("span", _hoisted_23, _toDisplayString(_ctx.panels.shinseishaInfo.torokuBushoNm), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_col, { span: 7 }, {
                      default: _withId(() => [
                        _hoisted_24,
                        _createVNode("span", _hoisted_25, _toDisplayString(_ctx.panels.shinseishaInfo.kanriKjnNm), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 7 }, {
                      default: _withId(() => [
                        _hoisted_26,
                        _createVNode("span", _hoisted_27, _toDisplayString(_ctx.panels.shinseishaInfo.kanriBushoNm), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_cus_panel, { title: "申請内容記入欄" }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_28, [
            _createVNode(_component_el_form, {
              model: _ctx.panels.shinseiForm,
              rules: _ctx.shinseiFormRules,
              ref: "shinseiFormRef",
              size: "small",
              "label-position": "top"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "委託先会社名",
                  prop: "itakusakiKaishaNm"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.panels.shinseiForm.itakusakiKaishaNm,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.panels.shinseiForm.itakusakiKaishaNm = $event)),
                      id: "itakusakiKaishaNm",
                      placeholder: "例）株式会社日本アルトマーク",
                      disabled: _ctx.isShinseiPanelDisable
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "委託先住所",
                  prop: "itakusakiJusho"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.panels.shinseiForm.itakusakiJusho,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.panels.shinseiForm.itakusakiJusho = $event)),
                      id: "itakusakiJusho",
                      placeholder: "例）〒108-0014　東京都港区芝1-1-1　アルトビル2階",
                      disabled: _ctx.isShinseiPanelDisable
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "再委託先会社名\t",
                  prop: "saiItakusakiKaishaNm"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.panels.shinseiForm.saiItakusakiKaishaNm,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.panels.shinseiForm.saiItakusakiKaishaNm = $event)),
                      id: "saiItakusakiKaishaNm",
                      placeholder: "例）株式会社日本アルトマーク",
                      disabled: _ctx.isShinseiPanelDisable
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "再委託先住所\t",
                  prop: "saiItakusakiJusho"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.panels.shinseiForm.saiItakusakiJusho,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.panels.shinseiForm.saiItakusakiJusho = $event)),
                      id: "saiItakusakiJusho",
                      placeholder: "例）〒108-0014　東京都港区芝1-1-1　アルトビル2階",
                      disabled: _ctx.isShinseiPanelDisable
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "開始日",
                  prop: "kikanKaishibi"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.panels.shinseiForm.kikanKaishibi,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.panels.shinseiForm.kikanKaishibi = $event)),
                      placeholder: "例）2021-04-01",
                      disabled: _ctx.isShinseiPanelDisable
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "終了日",
                  prop: "kikanShuryobi"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.panels.shinseiForm.kikanShuryobi,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.panels.shinseiForm.kikanShuryobi = $event)),
                      placeholder: "例）2022-3-31",
                      disabled: _ctx.isShinseiPanelDisable
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "利用場所（住所＋会社名＋部署名）",
                  prop: "riyoBasho",
                  class: "entire-row"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      autosize: { minRows: 3 },
                      modelValue: _ctx.panels.shinseiForm.riyoBasho,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.panels.shinseiForm.riyoBasho = $event)),
                      id: "riyoBasho",
                      placeholder: "MDBを実際に取り扱う場所として住所、会社名、部署名の3点を漏れなくご記入ください。部署名の記入が難しい場合、住所+会社名+\"△△会社オフィス内\"とご記入ください。",
                      disabled: _ctx.isShinseiPanelDisable
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "利用目的",
                  prop: "riyomokuteki",
                  class: "entire-row"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      autosize: { minRows: 3 },
                      modelValue: _ctx.panels.shinseiForm.riyomokuteki,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.panels.shinseiForm.riyomokuteki = $event)),
                      id: "riyomokuteki",
                      placeholder: "委託を行う目的をご記入ください。例）医薬品の新発売案内のダイレクトメール発送業務のため",
                      disabled: _ctx.isShinseiPanelDisable
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "利用方法",
                  prop: "riyohoho",
                  class: "entire-row"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      autosize: { minRows: 3 },
                      modelValue: _ctx.panels.shinseiForm.riyohoho,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.panels.shinseiForm.riyohoho = $event)),
                      id: "riyohoho",
                      placeholder: "委託先にて、ＭＤＢがどのように利用されるのかをご記入ください。例）委託元が作成したターゲットリストを基に、案内発送先に伴う宛先ラベル作成及び発送処理を行う",
                      disabled: _ctx.isShinseiPanelDisable
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "MDBファイル",
                  prop: "riyohani",
                  class: "entire-row asterisk"
                }, {
                  default: _withId(() => [
                    _createVNode("div", null, [
                      _createVNode(_component_el_checkbox, {
                        label: "DCF",
                        modelValue: _ctx.panels.shinseiForm.riyohaniDcfFlg,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.panels.shinseiForm.riyohaniDcfFlg = $event)),
                        id: "riyohaniDcfFlg",
                        border: "",
                        disabled: _ctx.isShinseiPanelDisable
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_el_checkbox, {
                        label: "DSF",
                        modelValue: _ctx.panels.shinseiForm.riyohaniDsfFlg,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.panels.shinseiForm.riyohaniDsfFlg = $event)),
                        id: "riyohaniDsfFlg",
                        border: "",
                        disabled: _ctx.isShinseiPanelDisable
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_el_checkbox, {
                        label: "DNF",
                        modelValue: _ctx.panels.shinseiForm.riyohaniDnfFlg,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.panels.shinseiForm.riyohaniDnfFlg = $event)),
                        id: "riyohaniDnfFlg",
                        border: "",
                        disabled: _ctx.isShinseiPanelDisable
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_el_checkbox, {
                        label: "ECF",
                        modelValue: _ctx.panels.shinseiForm.riyohaniEcfFlg,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.panels.shinseiForm.riyohaniEcfFlg = $event)),
                        id: "riyohaniEcfFlg",
                        border: "",
                        disabled: _ctx.isShinseiPanelDisable
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_el_checkbox, {
                        label: "PCF",
                        modelValue: _ctx.panels.shinseiForm.riyohaniPcfFlg,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.panels.shinseiForm.riyohaniPcfFlg = $event)),
                        id: "riyohaniPcfFlg",
                        border: "",
                        disabled: _ctx.isShinseiPanelDisable
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_el_checkbox, {
                        label: "その他",
                        modelValue: _ctx.panels.shinseiForm.riyohaniSonohokaFlg,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.panels.shinseiForm.riyohaniSonohokaFlg = $event)),
                        id: "riyohaniSonohokaFlg",
                        border: "",
                        disabled: _ctx.isShinseiPanelDisable
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_el_collapse_transition, null, {
                        default: _withId(() => [
                          _withDirectives(_createVNode("div", null, [
                            _createVNode(_component_el_input, {
                              type: "textarea",
                              class: "sonohoka-input",
                              modelValue: _ctx.panels.shinseiForm.riyohaniSonohokaText,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.panels.shinseiForm.riyohaniSonohokaText = $event)),
                              id: "riyohaniSonohokaText",
                              placeholder: "その他をご記入ください。",
                              disabled: _ctx.isShinseiPanelDisable
                            }, null, 8, ["modelValue", "disabled"])
                          ], 512), [
                            [_vShow, _ctx.panels.shinseiForm.riyohaniSonohokaFlg]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_29
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "利用項目",
                  prop: "riyokomoku",
                  class: "entire-row asterisk"
                }, {
                  default: _withId(() => [
                    _createVNode("div", null, [
                      _createVNode(_component_el_checkbox, {
                        label: "個人コード",
                        modelValue: _ctx.panels.shinseiForm.riyokomokuKjnCdFlg,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.panels.shinseiForm.riyokomokuKjnCdFlg = $event)),
                        id: "riyokomokuKjnCdFlg",
                        border: "",
                        disabled: _ctx.isShinseiPanelDisable
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_el_checkbox, {
                        label: "個人名",
                        modelValue: _ctx.panels.shinseiForm.riyokomokuKjnNmFlg,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.panels.shinseiForm.riyokomokuKjnNmFlg = $event)),
                        id: "riyokomokuKjnNmFlg",
                        border: "",
                        disabled: _ctx.isShinseiPanelDisable
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_el_checkbox, {
                        label: "施設コード",
                        modelValue: _ctx.panels.shinseiForm.riyokomokuShiCdFlg,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.panels.shinseiForm.riyokomokuShiCdFlg = $event)),
                        id: "riyokomokuShiCdFlg",
                        border: "",
                        disabled: _ctx.isShinseiPanelDisable
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_el_checkbox, {
                        label: "施設名",
                        modelValue: _ctx.panels.shinseiForm.riyokomokuShiNmFlg,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.panels.shinseiForm.riyokomokuShiNmFlg = $event)),
                        id: "riyokomokuShiNmFlg",
                        border: "",
                        disabled: _ctx.isShinseiPanelDisable
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_el_checkbox, {
                        label: "住所",
                        modelValue: _ctx.panels.shinseiForm.riyokomokuShiJushoFlg,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.panels.shinseiForm.riyokomokuShiJushoFlg = $event)),
                        id: "riyokomokuShiJushoFlg",
                        border: "",
                        disabled: _ctx.isShinseiPanelDisable
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_el_checkbox, {
                        label: "電話番号",
                        modelValue: _ctx.panels.shinseiForm.riyokomokuShiTelFlg,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.panels.shinseiForm.riyokomokuShiTelFlg = $event)),
                        id: "riyokomokuShiTelFlg",
                        border: "",
                        disabled: _ctx.isShinseiPanelDisable
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_el_checkbox, {
                        label: "診療科目",
                        modelValue: _ctx.panels.shinseiForm.riyokomokuSrkmFlg,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.panels.shinseiForm.riyokomokuSrkmFlg = $event)),
                        id: "riyokomokuSrkmFlg",
                        border: "",
                        disabled: _ctx.isShinseiPanelDisable
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_el_checkbox, {
                        label: "所属部科",
                        modelValue: _ctx.panels.shinseiForm.riyokomokuSzbkFlg,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.panels.shinseiForm.riyokomokuSzbkFlg = $event)),
                        id: "riyokomokuSzbkFlg",
                        border: "",
                        disabled: _ctx.isShinseiPanelDisable
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_el_checkbox, {
                        label: "その他",
                        modelValue: _ctx.panels.shinseiForm.riyokomokuSonohokaFlg,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.panels.shinseiForm.riyokomokuSonohokaFlg = $event)),
                        id: "riyokomokuSonohokaFlg",
                        border: "",
                        disabled: _ctx.isShinseiPanelDisable
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_el_collapse_transition, null, {
                        default: _withId(() => [
                          _withDirectives(_createVNode("div", null, [
                            _createVNode(_component_el_input, {
                              type: "textarea",
                              class: "sonohoka-input",
                              modelValue: _ctx.panels.shinseiForm.riyokomokuSonohokaText,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.panels.shinseiForm.riyokomokuSonohokaText = $event)),
                              id: "riyokomokuSonohokaText",
                              placeholder: "その他をご記入ください。",
                              disabled: _ctx.isShinseiPanelDisable
                            }, null, 8, ["modelValue", "disabled"])
                          ], 512), [
                            [_vShow, _ctx.panels.shinseiForm.riyokomokuSonohokaFlg]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_30
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "コメント",
                  prop: "shinseiComment",
                  class: "entire-row"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      autosize: { minRows: 3 },
                      modelValue: _ctx.panels.shinseiForm.shinseiComment,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.panels.shinseiForm.shinseiComment = $event)),
                      id: "shinseiComment",
                      disabled: _ctx.isShinseiPanelDisable
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                (!_ctx.isShinseiPanelDisable)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: "doiCheck",
                      class: "entire-row"
                    }, {
                      label: _withId(() => [
                        _createVNode(_component_Doijiko)
                      ]),
                      default: _withId(() => [
                        _createVNode(_component_el_checkbox, {
                          label: "同意する",
                          modelValue: _ctx.panels.shinseiForm.doiCheck,
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.panels.shinseiForm.doiCheck = $event)),
                          id: "doiCheck",
                          border: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ]),
        _: 1
      }),
      (_ctx.isShoninPanelVisible)
        ? (_openBlock(), _createBlock(_component_cus_panel, {
            key: 2,
            title: "Ultmarc記入欄"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_31, [
                _createVNode(_component_el_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withId(() => [
                        _hoisted_32,
                        _createVNode("span", _hoisted_33, _toDisplayString(_ctx.panels.shoninshaInfo.kanriTantoNm), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withId(() => [
                        _hoisted_34,
                        _createVNode("span", _hoisted_35, _toDisplayString(_ctx.panels.shoninshaInfo.torokuTantoNm), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form, {
                  model: _ctx.panels.shoninForm,
                  ref: "shoninFormRef",
                  rules: _ctx.shoninFormRules,
                  size: "small",
                  "label-position": "top"
                }, {
                  default: _withId(() => [
                    _withDirectives(_createVNode(_component_el_form_item, {
                      label: "申請分類名",
                      prop: "shinseiBunruiCd",
                      class: "entire-row"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.panels.shoninForm.shinseiBunruiCd,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.panels.shoninForm.shinseiBunruiCd = $event)),
                          id: "shinseiBunruiCd",
                          filterable: "",
                          "popper-class": "shinsei-bunrui",
                          disabled: _ctx.isShoninPanelDisable
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.shinseiBunruiOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.shinsei_bunrui_nm,
                                value: item.shinsei_bunrui_cd
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 512), [
                      [_directive_access, _ctx.ELEMENT_ACCESS.shinseiBunruiList]
                    ]),
                    _createVNode(_component_el_form_item, {
                      prop: "shoninComment",
                      class: "entire-row"
                    }, {
                      label: _withId(() => [
                        _createVNode(_component_el_link, {
                          icon: "el-icon-edit-outline",
                          onClick: _withModifiers(_ctx.handleSelect, ["prevent"]),
                          disabled: _ctx.isShoninPanelDisable
                        }, {
                          default: _withId(() => [
                            _hoisted_36
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ]),
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          autosize: { minRows: 3 },
                          modelValue: _ctx.panels.shoninForm.shoninComment,
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.panels.shoninForm.shoninComment = $event)),
                          id: "shoninComment",
                          disabled: _ctx.isShoninPanelDisable
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_37, [
      _createVNode("div", _hoisted_38, [
        _withDirectives(_createVNode("div", _hoisted_39, [
          (_ctx.displayButtons.shinseiBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "shinsei-btn",
                type: "primary",
                size: "medium",
                plain: "",
                onClick: _ctx.handleShinsei,
                loading: _ctx.loadings.shinseiBtn
              }, {
                default: _withId(() => [
                  _hoisted_40
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true),
          (_ctx.displayButtons.kariShinseiBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                class: "kari-shinsei-btn",
                type: "primary",
                size: "medium",
                plain: "",
                onClick: _ctx.handleKariShinsei,
                loading: _ctx.loadings.kariShinseiBtn
              }, {
                default: _withId(() => [
                  _hoisted_41
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true),
          (_ctx.displayButtons.kariShinseiOkBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                class: "shinsei-ok-btn",
                type: "success",
                size: "medium",
                plain: "",
                onClick: _ctx.handleShinseiOk,
                loading: _ctx.loadings.kariShinseiOkBtn
              }, {
                default: _withId(() => [
                  _hoisted_42
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true),
          (_ctx.displayButtons.copyBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 3,
                class: "copy-btn",
                type: "success",
                size: "medium",
                plain: "",
                onClick: _ctx.handleCopyShinsei,
                loading: _ctx.loadings.copyBtn
              }, {
                default: _withId(() => [
                  _hoisted_43
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true),
          (_ctx.displayButtons.saveBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 4,
                class: "save-btn",
                type: "success",
                size: "medium",
                plain: "",
                onClick: _ctx.handleSaveShinsei,
                loading: _ctx.loadings.saveBtn
              }, {
                default: _withId(() => [
                  _hoisted_44
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true),
          (_ctx.displayButtons.kariShinseiNgBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 5,
                class: "shinsei-ng-btn",
                type: "danger",
                size: "medium",
                plain: "",
                onClick: _ctx.handleShinseiNg,
                loading: _ctx.loadings.kariShinseiNgBtn
              }, {
                default: _withId(() => [
                  _hoisted_45
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true)
        ], 512), [
          [_directive_access, _ctx.ELEMENT_ACCESS.shinseishaButtons]
        ]),
        _withDirectives(_createVNode("div", _hoisted_46, [
          (_ctx.displayButtons.shoninBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "shonin-btn",
                type: "primary",
                size: "medium",
                plain: "",
                onClick: _ctx.handleShonin,
                loading: _ctx.loadings.shoninBtn
              }, {
                default: _withId(() => [
                  _hoisted_47
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true),
          (_ctx.displayButtons.kariShoninBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                class: "kari-shonin-btn",
                type: "primary",
                size: "medium",
                plain: "",
                onClick: _ctx.handleKariShonin,
                loading: _ctx.loadings.kariShoninBtn
              }, {
                default: _withId(() => [
                  _hoisted_48
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true),
          (_ctx.displayButtons.kariShoninOkBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                class: "shonin-ok-btn",
                type: "success",
                size: "medium",
                plain: "",
                onClick: _ctx.handleShoninOk,
                loading: _ctx.loadings.kariShoninOkBtn
              }, {
                default: _withId(() => [
                  _hoisted_49
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true),
          (_ctx.displayButtons.horyuBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 3,
                class: "horyu-btn",
                type: "warning",
                size: "medium",
                plain: "",
                onClick: _ctx.handleHoryu,
                loading: _ctx.loadings.horyuBtn
              }, {
                default: _withId(() => [
                  _hoisted_50
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true),
          (_ctx.displayButtons.kariHoryuBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 4,
                class: "kari-horyu-btn",
                type: "warning",
                size: "medium",
                plain: "",
                onClick: _ctx.handleKariHoryu,
                loading: _ctx.loadings.kariHoryuBtn
              }, {
                default: _withId(() => [
                  _hoisted_51
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true),
          (_ctx.displayButtons.kariHoryuOkBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 5,
                class: "horyu-ok-btn",
                type: "success",
                size: "medium",
                plain: "",
                onClick: _ctx.handleHoryuOk,
                loading: _ctx.loadings.kariHoryuOkBtn
              }, {
                default: _withId(() => [
                  _hoisted_52
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true),
          (_ctx.displayButtons.kariShoninNgBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 6,
                class: "shonin-ng-btn",
                type: "danger",
                size: "medium",
                plain: "",
                onClick: _ctx.handleShoninNg,
                loading: _ctx.loadings.kariShoninNgBtn
              }, {
                default: _withId(() => [
                  _hoisted_53
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true),
          (_ctx.displayButtons.kariHoryuNgBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 7,
                class: "horyu-ng-btn",
                type: "danger",
                size: "medium",
                plain: "",
                onClick: _ctx.handleHoryuNg,
                loading: _ctx.loadings.kariHoryuNgBtn
              }, {
                default: _withId(() => [
                  _hoisted_54
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true)
        ], 512), [
          [_directive_access, _ctx.ELEMENT_ACCESS.shoninshaButtons]
        ]),
        _createVNode("div", _hoisted_55, [
          (_ctx.displayButtons.deleteBtn)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "delete-btn",
                type: "danger",
                size: "medium",
                plain: "",
                onClick: _ctx.handleDeleteShinsei,
                loading: _ctx.loadings.deleteBtn
              }, {
                default: _withId(() => [
                  _hoisted_56
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", null, [
        _createVNode(_component_el_button, {
          class: "cancel-btn",
          size: "medium",
          plain: "",
          onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.handleCancel()))
        }, {
          default: _withId(() => [
            _hoisted_57
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_select_dialog, {
      title: "承認コメント選択",
      onCancel: _ctx.handleCloseDialog,
      modelValue: _ctx.selectDialogVisible,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.selectDialogVisible = $event))
    }, {
      default: _withId(() => [
        _createVNode(_component_ShoninComment, {
          isDialogMode: true,
          onSelect: _ctx.handleSelectInfo
        }, null, 8, ["onSelect"])
      ]),
      _: 1
    }, 8, ["onCancel", "modelValue"])
  ]))
})